import React from "react";

import "../../scss/organisms/_solutions-teaser.scss";

import Section from "../organisms/section";

import SolutionThink from "../atoms/solution-think";
import SolutionCreate from "../atoms/solution-create";
import SolutionAccelerate from "../atoms/solution-accelerate";
import Button from "../atoms/button";
import DictionaryEntry from "../atoms/dictionary-entry";

class SolutionsTeaser extends React.Component {
  render() {
    return (
      <Section className="solutions-teaser">
        <div className="solutions-teaser-heading">
          <h2 className="solutions-teaser-title">
            <span className="pronoun">We</span> think
            <br />
            <span className="pronoun">We</span> create
            <br />
            <span className="pronoun">We</span> accelerate
          </h2>
          <div className="solutions-teaser-media">
            <SolutionThink to="solutions#think" />
            <hr />
            <SolutionCreate to="solutions#create" />
            <hr />
            <SolutionAccelerate to="solutions#accelerate" />
            <hr />
          </div>
        </div>
        <div className="solutions-teaser-body">
          <p>
            <DictionaryEntry
              dictionaryEdges={this.props.dictionaryEdges}
              dictionaryKey="home-page.solution-teaser.body"
              language={this.props.language}
            />
          </p>
        </div>
        <div className="solutions-teaser-footer">
          <p>
            <DictionaryEntry
              dictionaryEdges={this.props.dictionaryEdges}
              dictionaryKey="home-page.solution-teaser.footer"
              language={this.props.language}
            />
            {/* <Button
              to="solutions"
              type="secondary"
              className="solutions-teaser-cta mt-4"
            >
              <DictionaryEntry
                dictionaryEdges={this.props.dictionaryEdges}
                dictionaryKey="home-page.solution-teaser.cta"
                language={this.props.language}
              />
            </Button> */}
          </p>
          <div className="text-center text-md-right pb-5 pb-md-0">
            <Button
              to="solutions"
              type="secondary"
              className="solutions-teaser-cta"
            >
              <DictionaryEntry
                dictionaryEdges={this.props.dictionaryEdges}
                dictionaryKey="home-page.solution-teaser.cta"
                language={this.props.language}
              />
            </Button>
          </div>
        </div>
      </Section>
    );
  }
}

export default SolutionsTeaser;
